export default "__VITE_ASSET__dvTrqXrd__"